import * as types from "./actionTypes";
import initialState from "reducers/initialState";
import * as eventTypes from "./eventTypes";

const contactModesReducer = (state = initialState.currentOffer.clientContactModesData, action) => {
  switch (action.type) {
    case types.LOAD_CONTACT_MODES_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_CONTACT_MODES_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_CONTACT_MODES_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_CONTACT_MODES_STARTED: {
      const { partnerId } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], saving: true };
      return result;
    }

    case types.UPDATE_CONTACT_MODES_SUCCEEDED: {
      const { partnerId, ids } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: true, saving: false, ids };
      return result;
    }

    case types.UPDATE_CONTACT_MODES_FAILED: {
      const { partnerId } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], saving: false };
      return result;
    }

    case eventTypes.CONTACT_MODES_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: false };
      return result;
    }

    default:
      return state;
  }
};

export default contactModesReducer;
